import React, { useState } from "react";
import "../assets/css/applyform.css";
import { useNavigate } from "react-router-dom";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng" || "https://10.0.0.57"
  : "http://localhost:3003";

const ApplyForm = ({ selectedProgramme, schoolName, fee }) => {
  const [alertMsg, setAlertMsg] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    confirmEmail: "",
  });

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleApplicationAndPayment = async (e) => {
  e.preventDefault();
  setAlertMsg("");
  setShowAlert(false);

  if (formData.email !== formData.confirmEmail) {
    setAlertMsg("Emails do not match!");
    setShowAlert(true);
    return;
  }

  setIsSubmitting(true);

  try {
    const res = await fetch(`${API_BASE_URL}/api/apply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...formData,
        schoolName,
        amount: fee,
      }),
    });

    const raw = await res.text();

    let data = {};
    try {
      data = raw ? JSON.parse(raw) : {};
    } catch {
      data = {
        msg: raw || "Unexpected server response.",
      };
    }

    if (!res.ok) {
      setAlertMsg(data.msg || `Application failed (${res.status})`);
      setShowAlert(true);
      return;
    }

    if (data.RRR) {
      window.location.href = `https://luth-school-payment.netlify.app/?code=${data.RRR}`;
    } else {
      setAlertMsg(data.msg || "Payment initialization failed.");
      setShowAlert(true);
    }
  } catch (err) {
    console.error(err);
    setAlertMsg("A server error occurred.");
    setShowAlert(true);
  } finally {
    setIsSubmitting(false);
  }
};
  return (
    <div className="apply-form-container">
      <h2 className="apply-form-title">
        Create Account to Apply {selectedProgramme}
      </h2>

      <div className="form-group">
        <label>Application Fee (₦)</label>
        <p className="fee-amount">{fee}</p>
      </div>

      <form onSubmit={handleApplicationAndPayment}>
        <div className="form-group">
          <div className="form-row">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-row">
            <label htmlFor="phone">Phone Number</label>
            <br/>
           <span>Enter your valid whatsapp number</span>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your whatsapp phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="form-row">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="confirmEmail">Confirm Email</label>
            <input
              type="email"
              name="confirmEmail"
              placeholder="Re-enter your email address"
              value={formData.confirmEmail}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <p className="form-note">
          Note: Ensure your email is correct. Your login details will be sent,
          Kindly click the button below once and wait for the popup to show.
        </p>

        {/* Input fields... */}
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Processing..." : "Submit & Pay"}
        </button>
      </form>
      {isSubmitting && (
        <div className="loading-overlay">
          <div className="spinner" />
        </div>
      )}

      {/* <iframe
        id="remitaFrame"
        title="Remita Payment"
        style={{
          width: "100%",
          height: "600px",
          border: "none",
          display: isSubmitting ? "none" : "block",
        }}
      ></iframe> */}

      {showAlert && (
        <div className="alert-overlay">
          <div className="alert-box">
            <h3>Error</h3>
            <p>{alertMsg}</p>
            <button onClick={() => setShowAlert(false)}>Close</button>
          </div>
        </div>
      )}

      {showConfirmation && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Application Successfully Submitted!</h3>
            <p>Your login details have been sent to your email.</p>
            <button onClick={() => setShowConfirmation(false)}>OK</button>
          </div>
        </div>
      )}

      {/* {showPaymentOptions && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Choose Payment Option</h3>
            <p>Click the button below to Proceed and pay via Remita</p>
            <div className="popup-actions">
              <button
                className={`remita-btn ${isPaying ? "loading" : ""}`}
                onClick={handlePayWithRemita}
                disabled={isPaying}
              >
                {isPaying ? "Processing…" : "Pay with Remita"}
              </button>
            </div>
            <button
              onClick={() => navigate("/applicant-login")}
              className="close-btn"
              style={{
                backgroundColor: "red",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                marginTop: "10px",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ApplyForm;
